const initialState = {};

export default function mapReducer(state = initialState, action) {
	switch (action.type) {
	case 'SAVE_TRAVEL_MAP':
		return {
			...state,
			travelMap: {
				center: action.center,
				zoom: action.zoom
			}
		};
	case 'SAVE_OUTBREAK_MAP':
		return {
			...state,
			outbreakMap: {
				center: action.center,
				zoom: action.zoom
			}
		};
	case 'SAVE_PREVALENCE_MAP':
		return {
			...state,
			prevalenceMap: {
				center: action.center,
				zoom: action.zoom
			}
		};
	default:
		return state;
	}
}
